import {Toast} from "vant"
import {locationTo} from "@/utils/url";
import {format, isBefore, isAfter, add} from 'date-fns'
import http from "@/utils/http"
import router from '@/router'

export const serviceJump = service => {
    // 检查服务有效期、权限等
    const expiryDateResult = isExpiry(service)
    if (service.stats && service.stats != 1) return Toast.fail('服务已暂停')
    if (expiryDateResult && service.showDetail !== 'true') return Toast.fail(expiryDateResult)
    // if (service.hasAuth !== 'true')  return Toast.fail('无使用权限')
    if (service.useType.indexOf('2')===-1)  return Toast.fail('移动端暂不支持此业务，请到PC端办理')
    if (service.service && service.service[2] && service.service[2].blisuse !== 'true' && service.showDetail !== 'true')  return Toast.fail('在线办理业务暂未开通')

    http.get('/nonlogin/elobby/service/start/mobile.htm?sid=' + service.id).then(function(resp) {
        if(/'(.+)'/.exec(resp) && (/'(.+)'/.exec(resp)).length > 1) {
            locationTo(/'(.+)'/.exec(resp)[1]);
        } else {
            router.push('/empty/forbidden/移动端暂不支持此业务,请到PC端办理');
        }
    });
}

/**
 * 服务介绍页跳转在线办理地址
 * @param serviceData 服务数据
 * @param blUrl 办理链接
 */
export const forward = (serviceData, blUrl) => {
    console.log('blUrl: ', blUrl);
    console.log('serviceData: ', serviceData);
    // 检查服务有效期、权限等
    let expiryDateResult = isExpiry(serviceData);
    if (expiryDateResult) return Toast.fail(expiryDateResult);
    if (serviceData.hasAuth !== 'true') return Toast.fail('无使用权限')
    if (serviceData.service && serviceData.service[2] && serviceData.service[2].blisuse != 'true')  Toast.fail('在线办理业务暂未开通')
    if (!blUrl) return Toast.fail('此服务未配置办理地址')
    locationTo(blUrl);
}

export const isExpiry = service => {
    const timeFormat = 'HH:mm',
        dayFormat = 'dd日 HH:mm',
        monthFormat = 'MM月dd日 HH:mm',
        dateTimeFormat = 'YYYY年MM月dd日 HH:mm',

        startDate = getAbsTime(service.startDate),
        endDate = getAbsTime(service.endDate),
        startTime = getAbsTime(service.startDateTime),
        endTime = getAbsTime(service.endDateTime),
        currentDate = getAbsTime(new Date().getTime()),
        weekendStartTime = getAbsTime(service.weekendStartTime),
        weekendEndTime = getAbsTime(service.weekendEndTime),
        weekend = service.weekend,
        currentWeek = new Date().getDay()

    let result = false

    try {
        if (service.expiryDate == '1') {
            result = false
        } else if (service.expiryDate == '2') {
            const startTimeStr = format(startTime, timeFormat),
                endTimeStr = format(endTime, timeFormat),
                currTimeStr = format(currentDate, timeFormat)

            if (currTimeStr < startTimeStr || currTimeStr > endTimeStr) {
                result = `该服务在每天${startTimeStr}至${endTimeStr}期间可以使用`
            }
        } else if (service.expiryDate == '3') {
            const startDayStr = format(startDate, dayFormat),
                endDayStr = format(endDate, dayFormat),
                currDayStr = format(currentDate, dayFormat)
            if (currDayStr < startDayStr || currDayStr > endDayStr) {
                result = `该服务在每月${startDayStr}至${endDayStr}期间可以使用`
            }
        } else if (service.expiryDate == '4') {
            const startMonthStr = format(startDate, monthFormat),
                endMonthStr = format(endDate, monthFormat),
                currMonthStr = format(currentDate, monthFormat)
            if (currMonthStr < startMonthStr || currMonthStr > endMonthStr) {
                result = `该服务在每年${startMonthStr}至${endMonthStr}期间可以使用`
            }
        } else if (service.expiryDate == '5'){
            const startDayStr = format(weekendStartTime, timeFormat),
                endDayStr = format(weekendEndTime, timeFormat),
                currDayStr = format(currentDate, timeFormat)
            const weekStr = getWeek(weekend)    
            if (weekend.indexOf(currentWeek) == -1 || currDayStr < startDayStr || currDayStr > endDayStr) {
                result = `该服务在每周${weekStr} ${startDayStr}至${endDayStr}期间可以使用`
            }
        } else {
            const isBeforeStartDate = isBefore(currentDate, startDate),
                isAfterEndDate = isAfter(currentDate, endDate),
                startDateStr = format(startDate, dateTimeFormat),
                endDateStr = format(add(endDate, {hours: 23, minutes: 59}), dateTimeFormat)

            if (service.startDate && !service.endDate && isBeforeStartDate) {
                result = `该服务将于${startDateStr}正式开启`
            } else if (!service.startDate && service.endDate && isAfterEndDate) {
                result = `该服务已于${endDateStr}停止使用`
            } else if (service.startDate && service.endDate && (isBeforeStartDate || isAfterEndDate)) {
                result = `该服务在${startDateStr}至<br>${endDateStr}期间可以使用`
            }
        }
    } catch (e) {
        console.warn(e)
    }
    return result
}

function getAbsTime(time) {
    time = parseInt(time);
    var timezone = 8; //目标时区时间，东八区
    var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
    return new Date(time + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000);
}

function getWeek(week) {
    const weekDate = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    var weekArr = week.split(',');
    var weekStr = '';
    for (var i = 0; i < weekArr.length; i++) {
        weekStr += weekDate[weekArr[i]] + '、';
    }
    weekStr = weekStr.substring(0, weekStr.length - 1);
    return weekStr;
}